import { render, staticRenderFns } from "./TeacherManagePage.vue?vue&type=template&id=5edad1da&scoped=true&"
import script from "./TeacherManagePage.vue?vue&type=script&lang=js&"
export * from "./TeacherManagePage.vue?vue&type=script&lang=js&"
import style0 from "./TeacherManagePage.vue?vue&type=style&index=0&id=5edad1da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edad1da",
  null
  
)

export default component.exports